import React from "react"
import { useMediaQuery } from "react-responsive"
import { Grid, Image, Typography, Box } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { ListFavorite } from "src/openapi"

interface Props {
  item: ListFavorite
  handleSelected: any
  handleCanceled: any
}
export const FavoriteVideoItem = ({ item, handleSelected, handleCanceled }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const { t } = useTranslation("translation", { keyPrefix: "mypage.favorite_video" })

  return (
    <Grid
      item
      xl={3}
      lg={3}
      md={12}
      sm={12}
      xs={12}
      sx={{ mt: isTablet ? "20px" : "10px", px: isTablet ? "10px" : "10px", mb: "20px" }}
    >
      <Box position="relative">
        <Image
          src={item.imageUrl!}
          sx={{
            height: "177px",
            bgcolor: "divider",
            flex: 1,
            ":hover": { opacity: 0.8, cursor: "pointer" },
          }}
          imageStyle={{ width: "100%", height: "100%" }}
          onClick={() => handleSelected(item.eventId)}
        />
        <Typography.Description
          className="notosans weight700"
          color="textPrimary"
          fontSize="14px"
          lineHeight="14px"
          sx={{
            height: "26px",
            position: "absolute",
            bgcolor: "#235496",
            color: "white",
            left: 0,
            top: 0,
            px: "10px",
            pt: "6px",
          }}
        >
          {t("archive")}
        </Typography.Description>
      </Box>
      <Typography.Description
        className="weight500 limit_line"
        color="textPrimary"
        fontSize="20px"
        lineHeight="20px"
        sx={{ my: "10px", ":hover": { opacity: 0.8, cursor: "pointer" } }}
        onClick={() => handleSelected(item.eventId)}
      >
        {item.title}
      </Typography.Description>
      <Typography.Description
        className="weight500 notosans restrict_line"
        color="textPrimary"
        fontSize="14px"
        lineHeight="14px"
        sx={{ my: "10px", ":hover": { opacity: 0.8, cursor: "pointer" } }}
        onClick={() => handleSelected(item.eventId)}
      >
        {item.description}
      </Typography.Description>
      <Box
        display="flex"
        sx={{
          justifyContent: "right",
        }}
      >
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#FC3317",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#FC3317",
            fontSize: "13px",
            ":hover": { opacity: 0.8, cursor: "pointer" },
          }}
          onClick={() => handleCanceled(item.id)}
        >
          {t("cancel_favorite")}
        </Typography.InputFieldRequired>
      </Box>
    </Grid>
  )
}
